/**
 * Dropdown options for measurements form.
 * Formats: height 7'0" (tenth/hundredth only when needed); weight "195 lbs.";
 * hands/vert quarter inches; body fat quarter %; shuttle/sprint seconds (hundredth).
 */

// Height: 5'0" through 8'0" in quarter inches (e.g. 6'7.75", 7'0", 8'0")
function buildHeightOptions() {
  const options = [{ value: "", label: "" }];
  for (let feet = 5; feet <= 8; feet += 1) {
    const maxInches = feet === 8 ? 0 : 11.75;
    for (let inc = 0; inc <= maxInches * 4; inc += 1) {
      const inches = inc * 0.25;
      const inchWhole = Math.floor(inches);
      const frac = inches - inchWhole;
      let label;
      if (frac === 0) label = `${feet}'${inchWhole}"`;
      else if (frac === 0.25) label = `${feet}'${inchWhole}.25"`;
      else if (frac === 0.5) label = `${feet}'${inchWhole}.5"`;
      else label = `${feet}'${inchWhole}.75"`;
      options.push({ value: label, label });
    }
  }
  return options;
}

// Weight: 150 lbs. to 300 lbs. in 1 lb steps
function buildWeightOptions() {
  const options = [{ value: "", label: "" }];
  for (let w = 150; w <= 300; w += 1) {
    const label = `${w} lbs.`;
    options.push({ value: label, label });
  }
  return options;
}

// Hand length/width: 6" to 13" in quarter inches (9", 9.25", 9.5", 9.75")
function buildHandOptions() {
  const options = [{ value: "", label: "" }];
  for (let i = 24; i <= 52; i += 1) {
    const inches = i * 0.25;
    let label;
    if (inches === Math.floor(inches)) label = `${inches}"`;
    else label = `${inches.toFixed(2)}"`;
    options.push({ value: label, label });
  }
  return options;
}

// Vertical jump: 20" to 60" in quarter inches
function buildVerticalJumpOptions() {
  const options = [{ value: "", label: "" }];
  for (let i = 80; i <= 240; i += 1) {
    const inches = i * 0.25;
    let label;
    if (inches === Math.floor(inches)) label = `${inches}"`;
    else label = `${inches.toFixed(2)}"`;
    options.push({ value: label, label });
  }
  return options;
}

// Body fat %: 3% to 25% in quarter percent (12%, 12.25%, 12.5%, 12.75%)
function buildBodyFatOptions() {
  const options = [{ value: "", label: "" }];
  for (let i = 12; i <= 100; i += 1) {
    const pct = i * 0.25;
    let label;
    if (pct === Math.floor(pct)) label = `${pct}%`;
    else label = `${pct.toFixed(2)}%`;
    options.push({ value: label, label });
  }
  return options;
}

// Shuttle: 4.00 to 15.00 seconds in 0.01 steps (use 0.05 for dropdown size: 4.00, 4.05, ...)
function buildShuttleOptions() {
  const options = [{ value: "", label: "" }];
  for (let i = 400; i <= 1500; i += 5) {
    const sec = i / 100;
    const label = sec % 1 === 0 ? `${sec}.0` : sec.toFixed(2);
    options.push({ value: label, label });
  }
  return options;
}

// Sprint: 2.50 to 5.50 seconds in 0.01 steps (use 0.05: 2.5, 2.55, ...)
function buildSprintOptions() {
  const options = [{ value: "", label: "" }];
  for (let i = 250; i <= 550; i += 5) {
    const sec = i / 100;
    const label = sec % 1 === 0 ? `${sec}.0` : sec.toFixed(2);
    options.push({ value: label, label });
  }
  return options;
}

// Feet-inches options: minFeet to maxFeet (inclusive), quarter-inch steps
function buildFeetInchesOptions(minFeet, maxFeet) {
  const options = [{ value: "", label: "" }];
  for (let feet = minFeet; feet <= maxFeet; feet += 1) {
    const maxInches = feet === maxFeet ? 0 : 11.75;
    for (let inc = 0; inc <= maxInches * 4; inc += 1) {
      const inches = inc * 0.25;
      const inchWhole = Math.floor(inches);
      const frac = inches - inchWhole;
      let label;
      if (frac === 0) label = `${feet}'${inchWhole}"`;
      else if (frac === 0.25) label = `${feet}'${inchWhole}.25"`;
      else if (frac === 0.5) label = `${feet}'${inchWhole}.5"`;
      else label = `${feet}'${inchWhole}.75"`;
      options.push({ value: label, label });
    }
  }
  return options;
}

export const HEIGHT_OPTIONS = buildHeightOptions();
export const WEIGHT_OPTIONS = buildWeightOptions();
export const WINGSPAN_OPTIONS = buildFeetInchesOptions(5, 9);   // up to 9 feet
export const STANDING_REACH_OPTIONS = buildFeetInchesOptions(5, 11); // up to 11 feet
export const HAND_L_OPTIONS = buildHandOptions();
export const HAND_W_OPTIONS = buildHandOptions();
export const VERT_MAX_OPTIONS = buildVerticalJumpOptions();
export const VERT_NO_STEP_OPTIONS = buildVerticalJumpOptions();
export const BODY_FAT_OPTIONS = buildBodyFatOptions();
export const SHUTTLE_OPTIONS = buildShuttleOptions();
export const SPRINT_OPTIONS = buildSprintOptions();
